import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

/**
 * UrlInterceptor intercepts HTTP requests to modify the request URL.
 * It appends the base API URL from the environment configuration to the request URL
 * unless the URL already includes the base API URL or refers to assets.
 */
@Injectable()
export class UrlInterceptor implements HttpInterceptor {

  /**
   * Constructs the UrlInterceptor.
   */
  constructor() {
  }

  /**
   * Intercepts HTTP requests and modifies the URL if necessary.
   *
   * @param {HttpRequest<unknown>} request - The outgoing HTTP request.
   * @param {HttpHandler} next - The next interceptor in the chain.
   * @returns {Observable<HttpEvent<unknown>>} An observable of the HTTP event.
   */
  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    let clonnedRequest: HttpRequest<unknown> = request.clone();
    if (request.url.includes(environment.ApiAppUrl)) {
      return next.handle(clonnedRequest);
    }

    if (request.url.includes('assets')) {
      return next.handle(clonnedRequest);
    }
    clonnedRequest = request.clone({
      url: `${environment.ApiAppUrl}${request.url}`
    });

    return next.handle(clonnedRequest);
  }
}
